import React, { Component } from 'react';
// import history from '../../config/history';
import { withRouter } from 'react-router-dom';
import AmplifySdk from '../../helpers/amplify';
import './SideBar.css';
import '../../App.css';
import AppContext from '../../helpers/context';
import { getUserProfile } from '../../services/private/company.service';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import AreYouSureModal from '../Modals/AreYouSureModal';
import { ReactComponent as InventoryIcon } from '../../assets/icons/inventory.svg'
import { ReactComponent as ProjectIcon } from '../../assets/icons/projectSidebar.svg';
import { ReactComponent as LearningCenterIcon } from '../../assets/icons/learningCenter.svg';
import { ReactComponent as DashboardIcon } from '../../assets/home_icon.svg';
import TooltipText from '../Tooltip';
const Amplify = AmplifySdk();

const getSubText = () => {
  if (localStorage.getItem('fb_steps') && +localStorage.getItem('fb_steps') < 4) {
    return `Do you wish to cancel Integration? Changes that you have made may not have been saved.`
  }
  if (localStorage.getItem('project_state') === 'create') {
    return "Do you want to cancel the project creation? Any unsaved changes you made may be lost."
  }
}

class SideBar extends Component {

  state = {
    currentSelected: this.props.location.pathname,
    isOwner: false, role: localStorage.getItem('role'),
    redirectURL: '',
    showRedirectConfirmationModal: false,
    currentRoute: this.props.location.pathname.split('/'),
    allowedPermissions: [],
    isRolesModule: false,
    allowedModules: [],
    companyId: ''
  }
  constructor(props) {
    super(props);
    this.sidebarRef = React.createRef();
  }

  async getUserProfileData() {
    await getUserProfile().then(res => {
      if (res.status === 200) {
        this.setState({
          ...this.state,
          isOwner: res.data.data.is_owner,
          role: res.data.data.role_name,
          allowedPermissions: res.data.data.role?.allowed_permissions || [],
          isRolesModule: res.data.data.is_roles_module,
          allowedModules: res.data.data?.allowed_modules || [],
          companyId: res.data.data.company_id
        })
      }
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.location !== prevProps.location) {
      this.setState({ currentRoute: this.props.location.pathname.split('/') });
    }
  }

  componentDidMount() {
    this.getUserProfileData();
    document.addEventListener('click', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }

  handleClickOutside = (e) => {
    if (this.sidebarRef.current && !this.sidebarRef.current.contains(e.target)) {
      const el = document.getElementById('main-container');
      if (el.classList.contains('open-sidebar') && !el.classList.contains('user-settings')) {
        el.classList.remove('open-sidebar');
        document.getElementById('hamburger_icon').style.display = 'block';
        document.getElementById('close_icon').style.display = 'none';
      }
    }
  }

  render() {

    return (
      <AppContext.Consumer>
        {({ authorized, setAuthorized }) => (
          <div className="sidebar" ref={this.sidebarRef}>
            <ul>
              {/* Leads dashboard */}
              <li name='dashboard' className={`${this.props.location.pathname.split("/")[1] == 'dashboard' ? "active " : ""} dashboard`}>

                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip id="button-tooltip" className='sidebar-tooltip' >
                      <div className='info-msg'>
                        {/* <h4>Total Leads</h4> */}
                        <p className='d-flex fz18'>Dashboard</p>
                      </div>
                    </Tooltip>
                  }
                >
                  <Button className='bg-tr border-0 p-0' bsstyle="default" onClick={() => {
                    this.props.toggleSidebar();

                    this.navigateToRoute("/dashboard");
                  }}>

                    <DashboardIcon className='!stroke-[#667085]' />
                  </Button>
                </OverlayTrigger>
              </li>
              {/* Leads Manager */}
              <li name='lead dashboard' className={(this.props.location.pathname.split("/")[1] === 'leads') ? "active" : ""} >
                <OverlayTrigger
                  placement="right"

                  overlay={
                    <Tooltip id="button-tooltip" className='sidebar-tooltip' >
                      <div className='info-msg'>
                        <p className='d-flex fz18'>Leads Manager</p>
                      </div>
                    </Tooltip>
                  }
                >
                  <Button className='bg-tr border-0 p-0' bsstyle="default" onClick={() => {
                    // this.props.toggleSidebar();
                    this.navigateToRoute("/leads");
                  }} >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path fillRule="evenodd" clipRule="evenodd" d="M8.3 13.7V10.3H4V13.7H8.3ZM10.3 13.7H20V10.3H10.3V13.7ZM8.3 4H5C4.44772 4 4 4.44772 4 5V8.3H8.3V4ZM10.3 4V8.3H20V5C20 4.44772 19.5523 4 19 4H10.3ZM8.3 20V15.7H4V19C4 19.5523 4.44772 20 5 20H8.3ZM10.3 20H19C19.5523 20 20 19.5523 20 19V15.7H10.3V20ZM2 19V5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19Z" fill="#92929D" />
                    </svg>
                  </Button>
                </OverlayTrigger>
              </li>

              {/* Learning Center */}
              {(this.state.isOwner || this.state.allowedPermissions?.includes('learning_center_access')) &&
                <li name='learning' className={this.props.location.pathname.split("/")[1] == 'learning-center' ? "active learning" : "learning"} >

                  <OverlayTrigger
                    placement="right"
                    overlay={
                      <Tooltip id="button-tooltip" className='sidebar-tooltip' >
                        <div className='info-msg'>
                          {/* <h4>Total Leads</h4> */}
                          <p className='d-flex fz18'>Learning Center</p>
                        </div>
                      </Tooltip>
                    }
                  >
                    <Button className='bg-tr border-0 p-0' bsstyle="default" onClick={() => {
                      this.props.toggleSidebar();
                      if (((this.state.currentRoute.includes('new-integration') ||
                        this.state.currentRoute[this.state.currentRoute.length - 1].split('?').includes('new-integration')) &&
                        (localStorage.getItem('fb_steps') && +localStorage.getItem('fb_steps') < 4)) || localStorage.getItem('project_state') === 'create') {

                        if (this.state.currentRoute.includes('create-projects') || this.state.currentRoute.includes('new-integration')) {
                          this.setState({
                            redirectURL: '/learning-center',
                            showRedirectConfirmationModal: true
                          })
                          return;

                        }
                      }
                      this.navigateToRoute("/learning-center");
                    }}>
                      {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M7 12H6C3.79086 12 2 13.7909 2 16V18C2 20.2091 3.79086 22 6 22H7C9.20914 22 11 20.2091 11 18V16C11 13.7909 9.20914 12 7 12ZM4 16C4 14.8954 4.89543 14 6 14H7C8.10457 14 9 14.8954 9 16V18C9 19.1046 8.10457 20 7 20H6C4.89543 20 4 19.1046 4 18V16Z" fill="#92929D" />
                        <path fillRule="evenodd" clipRule="evenodd" d="M9 5.5C9 3.567 7.433 2 5.5 2C3.567 2 2 3.567 2 5.5V6.5C2 8.433 3.567 10 5.5 10C7.433 10 9 8.433 9 6.5V5.5ZM4 5.5C4 4.67157 4.67157 4 5.5 4C6.32843 4 7 4.67157 7 5.5V6.5C7 7.32843 6.32843 8 5.5 8C4.67157 8 4 7.32843 4 6.5V5.5Z" fill="#92929D" />
                        <path fillRule="evenodd" clipRule="evenodd" d="M18 11H17C14.7909 11 13 12.7909 13 15V18C13 20.2091 14.7909 22 17 22H18C20.2091 22 22 20.2091 22 18V15C22 12.7909 20.2091 11 18 11ZM15 15C15 13.8954 15.8954 13 17 13H18C19.1046 13 20 13.8954 20 15V18C20 19.1046 19.1046 20 18 20H17C15.8954 20 15 19.1046 15 18V15Z" fill="#92929D" />
                        <path fillRule="evenodd" clipRule="evenodd" d="M18.5 2H14.5C12.567 2 11 3.567 11 5.5C11 7.433 12.567 9 14.5 9H18.5C20.433 9 22 7.433 22 5.5C22 3.567 20.433 2 18.5 2ZM13 5.5C13 4.67157 13.6716 4 14.5 4H18.5C19.3284 4 20 4.67157 20 5.5C20 6.32843 19.3284 7 18.5 7H14.5C13.6716 7 13 6.32843 13 5.5Z" fill="#92929D" />
                      </svg> */}
                      <LearningCenterIcon />
                    </Button>
                  </OverlayTrigger>
                </li>}

              {/* Inventory */}

              <li name='project' className={this.props.location.pathname.split("/")[1] == 'projects' ? "active" : ""} >
                <TooltipText title='Projects' placement="right">
                  <Button className='bg-tr border-0 p-0' bsstyle="default" onClick={() => {
                    this.props.toggleSidebar();
                    if (((this.state.currentRoute.includes('new-integration') ||
                      this.state.currentRoute[this.state.currentRoute.length - 1].split('?').includes('new-integration')) &&
                      (localStorage.getItem('fb_steps') && +localStorage.getItem('fb_steps') < 4)) || localStorage.getItem('project_state') === 'create') {

                      if (this.state.currentRoute.includes('create-projects') || this.state.currentRoute.includes('new-integration')) {
                        this.setState({
                          redirectURL: '/projects',
                          showRedirectConfirmationModal: true
                        })
                        return;
                      }
                    }
                    this.navigateToRoute("/projects");
                  }}>
                    {/* <InventoryIcon /> */}
                    {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g id="icon_line/home_1">
                        <path id="Vector" fillRule="evenodd" clipRule="evenodd" d="M6.67943 4.38462C6.2424 4.38462 5.84285 4.63154 5.64743 5.02245L4.81248 6.69231H19.1875L18.3526 5.02245C18.1572 4.63154 17.7576 4.38462 17.3206 4.38462H6.67943ZM19.6154 8.07692H4.38462V18.4615C4.38462 19.0988 4.90121 19.6154 5.53846 19.6154H18.4615C19.0988 19.6154 19.6154 19.0988 19.6154 18.4615V8.07692ZM4.40898 4.40322C4.83897 3.54324 5.71795 3 6.67943 3H17.3206C18.282 3 19.161 3.54324 19.591 4.40323L20.9269 7.07502C20.975 7.17115 21 7.27712 21 7.38462V18.4615C21 19.8635 19.8635 21 18.4615 21H5.53846C4.13651 21 3 19.8635 3 18.4615V7.38462C3 7.27712 3.02502 7.17115 3.07309 7.07502L4.40898 4.40322Z" fill="#92929D" stroke="#92929D" strokeWidth="0.5" />
                        <path id="Vector_2" fillRule="evenodd" clipRule="evenodd" d="M9 16.6923C9 16.31 9.30997 16 9.69231 16H14.3077C14.69 16 15 16.31 15 16.6923C15 17.0746 14.69 17.3846 14.3077 17.3846H9.69231C9.30997 17.3846 9 17.0746 9 16.6923Z" fill="#92929D" stroke="#92929D" strokeWidth="0.5" />
                      </g>
                    </svg> */}
                    <ProjectIcon />
                  </Button>
                </TooltipText>
              </li>





              {/* Setting */}
              <li name='setting' className={['project-launchpad', 'settings'].includes(this.props.location.pathname.split("/")[1]) ? "active" : ""} >
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip id="button-tooltip" className='sidebar-tooltip' >
                      <div className='info-msg'>
                        {/* <h4>Total Leads</h4> */}
                        <p className='d-flex fz18'>Settings</p>
                      </div>
                    </Tooltip>
                  }
                >
                  <Button className='bg-tr border-0 p-0' bsstyle="default" onClick={() => {
                    if (((this.state.currentRoute.includes('new-integration') ||
                      this.state.currentRoute[this.state.currentRoute.length - 1].split('?').includes('new-integration')) &&
                      (localStorage.getItem('fb_steps') && +localStorage.getItem('fb_steps') < 4)) || localStorage.getItem('project_state') === 'create') {

                      if (this.state.currentRoute.includes('create-projects') || this.state.currentRoute.includes('new-integration')) {
                        this.setState({
                          redirectURL: '/settings/my-profile',
                          showRedirectConfirmationModal: true
                        })
                        return;

                      }
                    }
                    this.navigateToRoute("/settings/my-profile");
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path fillRule="evenodd" clipRule="evenodd" d="M12 15.6316C14.0216 15.6316 15.6605 14.0057 15.6605 12C15.6605 9.99433 14.0216 8.36842 12 8.36842C9.97838 8.36842 8.33953 9.99433 8.33953 12C8.33953 14.0057 9.97838 15.6316 12 15.6316ZM12 13.6316C11.0917 13.6316 10.3554 12.9011 10.3554 12C10.3554 11.0989 11.0917 10.3684 12 10.3684C12.9083 10.3684 13.6446 11.0989 13.6446 12C13.6446 12.9011 12.9083 13.6316 12 13.6316Z" fill="#667085" />
                      <path fillRule="evenodd" clipRule="evenodd" d="M9.09429 3.33907C9.38357 1.97584 10.5958 1 12 1C13.4042 1 14.6164 1.97584 14.9057 3.33907L14.962 3.60457C16.0187 3.97101 16.9989 4.53018 17.8497 5.2566L18.1074 5.17298C19.442 4.73991 20.9 5.29353 21.6021 6.5C22.3042 7.70647 22.0585 9.23593 21.0131 10.1661L20.8113 10.3457C21.02 11.4399 21.018 12.5617 20.8095 13.6528L21.0131 13.8339C22.0585 14.7641 22.3042 16.2935 21.6021 17.5C20.9 18.7065 19.442 19.2601 18.1074 18.827L17.8489 18.7431C17.4276 19.1021 16.971 19.4234 16.4827 19.7031C15.9945 19.9827 15.4857 20.2144 14.9617 20.3969L14.9057 20.6609C14.6164 22.0242 13.4042 23 12 23C10.5958 23 9.38357 22.0242 9.09429 20.6609L9.03795 20.3954C7.98129 20.029 7.00107 19.4698 6.1503 18.7434L5.8926 18.827C4.55798 19.2601 3.10004 18.7065 2.39794 17.5C1.69584 16.2935 1.94155 14.7641 2.98689 13.8339L3.18874 13.6543C2.98002 12.5601 2.98202 11.4383 3.19048 10.3472L2.98689 10.1661C1.94155 9.23593 1.69584 7.70647 2.39794 6.5C3.10004 5.29353 4.55798 4.73991 5.8926 5.17298L6.1511 5.25686C6.57236 4.89792 7.02899 4.5766 7.51725 4.29693C8.00551 4.01726 8.51431 3.78559 9.03826 3.60311L9.09429 3.33907ZM12 3C11.5491 3 11.1598 3.31335 11.067 3.75109L10.8893 4.58834C10.8115 4.95506 10.5335 5.24784 10.1692 5.34682C9.59911 5.50169 9.04777 5.72966 8.52521 6.02898C8.00265 6.3283 7.52798 6.68802 7.10776 7.10038C6.83919 7.36392 6.44464 7.45636 6.0856 7.33986L5.26593 7.07388C4.83737 6.93482 4.36922 7.1126 4.14377 7.5C3.91832 7.8874 3.99722 8.37852 4.33289 8.6772L4.97653 9.24993C5.25789 9.50029 5.37444 9.88578 5.27841 10.2484C4.97456 11.396 4.97134 12.6029 5.27656 13.7524C5.37291 14.1152 5.25641 14.501 4.97486 14.7516L4.33289 15.3228C3.99722 15.6215 3.91832 16.1126 4.14377 16.5C4.36922 16.8874 4.83737 17.0652 5.26593 16.9261L6.08555 16.6602C6.44502 16.5435 6.84005 16.6363 7.10861 16.9005C7.95939 17.7375 9.01454 18.3382 10.1682 18.6509C10.5328 18.7497 10.811 19.0426 10.8888 19.4095L11.067 20.2489C11.1598 20.6867 11.5491 21 12 21C12.4509 21 12.8402 20.6867 12.933 20.2489L13.1107 19.4117C13.1885 19.0449 13.4665 18.7522 13.8308 18.6532C14.4009 18.4983 14.9522 18.2703 15.4748 17.971C15.9974 17.6717 16.472 17.312 16.8922 16.8996C17.1608 16.6361 17.5554 16.5436 17.9144 16.6601L18.7341 16.9261C19.1626 17.0652 19.6308 16.8874 19.8562 16.5C20.0817 16.1126 20.0028 15.6215 19.6671 15.3228L19.0235 14.7501C18.7421 14.4997 18.6256 14.1142 18.7216 13.7516C19.0254 12.604 19.0287 11.3971 18.7234 10.2476C18.6271 9.88479 18.7436 9.49897 19.0251 9.24844L19.6671 8.6772C20.0028 8.37852 20.0817 7.8874 19.8562 7.5C19.6308 7.1126 19.1626 6.93482 18.7341 7.07388L17.9144 7.33984C17.555 7.45649 17.1599 7.36367 16.8914 7.09947C16.0406 6.2625 14.9855 5.6618 13.8318 5.3491C13.4672 5.25027 13.189 4.95739 13.1112 4.59046L12.933 3.75109C12.8402 3.31335 12.4509 3 12 3Z" fill="#667085" />
                    </svg>
                  </Button>
                </OverlayTrigger>
              </li>
            </ul>
            <div className="logout">
              <OverlayTrigger
                placement="right"

                overlay={
                  <Tooltip id="button-tooltip" className='secure-btn'>
                    <div className='info-msg'>
                      {/* <h4>Total Leads</h4> */}
                      <p className='d-flex secure-para'><svg style={{ widht: '24px' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M7.532 1.46345C7.79508 1.36502 8.08253 1.35219 8.35333 1.42679L8.468 1.46345L13.1347 3.21345C13.3713 3.30218 13.5778 3.45632 13.7302 3.65792C13.8826 3.85952 13.9745 4.10027 13.9953 4.35212L14 4.46212V8.03745C14 9.11773 13.7083 10.178 13.1557 11.1062C12.6032 12.0345 11.8103 12.7964 10.8607 13.3115L10.6833 13.4041L8.44733 14.5221C8.32422 14.5836 8.18974 14.619 8.05231 14.6261C7.91489 14.6332 7.77747 14.6119 7.64867 14.5635L7.55267 14.5221L5.31667 13.4041C4.35041 12.921 3.53252 12.1859 2.94934 11.2765C2.36616 10.3671 2.03932 9.31717 2.00333 8.23745L2 8.03745V4.46212C2 4.20954 2.07175 3.96215 2.20689 3.74877C2.34203 3.53538 2.535 3.36476 2.76333 3.25679L2.86533 3.21345L7.532 1.46345ZM10.2887 5.75279L7.22333 8.81812L6.04467 7.63945C5.91957 7.51445 5.74994 7.44425 5.5731 7.44432C5.39625 7.44438 5.22667 7.51469 5.10167 7.63979C4.97666 7.76488 4.90647 7.93451 4.90653 8.11135C4.90659 8.2882 4.97691 8.45778 5.102 8.58278L6.70467 10.1855C6.77277 10.2536 6.85362 10.3076 6.94262 10.3445C7.03161 10.3814 7.127 10.4004 7.22333 10.4004C7.31966 10.4004 7.41505 10.3814 7.50405 10.3445C7.59304 10.3076 7.6739 10.2536 7.742 10.1855L11.2313 6.69545C11.295 6.63395 11.3458 6.56039 11.3807 6.47906C11.4157 6.39772 11.4341 6.31024 11.4348 6.22172C11.4356 6.1332 11.4187 6.04541 11.3852 5.96348C11.3517 5.88155 11.3022 5.80712 11.2396 5.74452C11.177 5.68193 11.1026 5.63242 11.0206 5.5989C10.9387 5.56538 10.8509 5.54852 10.7624 5.54929C10.6739 5.55005 10.5864 5.56845 10.5051 5.60338C10.4237 5.63832 10.3502 5.68911 10.2887 5.75279Z" fill="#fff" />
                      </svg> Your Data is fully secure on Propacity Platform.</p>
                    </div>
                  </Tooltip>
                }
              >
                <Button className='bg-tr border-0 p-0' bsstyle="default">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M21.6142 3.81004C18.7383 1.97441 15.4042 1 12.0001 1C8.5959 1 5.26215 1.97441 2.3859 3.81004C2.14535 3.96427 1.99984 4.2317 2 4.519V11.8375C2.0026 13.8239 2.57113 15.7675 3.638 17.4377C4.70475 19.1076 6.22475 20.4336 8.01758 21.2579L11.6551 22.9246H11.655C11.8742 23.0251 12.1258 23.0251 12.345 22.9246L15.9826 21.2579H15.9824C17.7752 20.4336 19.2952 19.1076 20.362 17.4377C21.4289 15.7676 21.9974 13.824 22 11.8375V4.519C22.0002 4.23171 21.8547 3.96428 21.6141 3.81004H21.6142ZM20.3335 11.8375C20.3312 13.5014 19.855 15.1295 18.9614 16.5284C18.0677 17.9273 16.7944 19.0378 15.2926 19.7283L12.0001 21.2361L8.70761 19.724C7.20649 19.0339 5.93353 17.924 5.03999 16.5259C4.14644 15.1278 3.66986 13.5007 3.66678 11.8376V4.98783C6.18811 3.47688 9.06719 2.67934 12.0001 2.67934C14.933 2.67934 17.8122 3.47688 20.3334 4.98783L20.3335 11.8375Z" fill="#0062FF" />
                    <path d="M16.1082 10.7149C16.1082 10.0124 15.5369 9.44126 14.8346 9.44121C14.8345 9.44121 14.8345 9.44121 14.8345 9.44121H14.5629V8.36063C14.5629 6.92947 13.399 5.76523 11.9679 5.76523C10.5369 5.76523 9.37298 6.92943 9.37298 8.36063V9.44121H9.10128C8.39902 9.44121 7.82773 10.0125 7.82773 10.7149V14.9117C7.82773 15.6143 8.39903 16.1854 9.10128 16.1854H14.8346C15.5369 16.1854 16.1082 15.6141 16.1082 14.9117V10.7149ZM10.6423 8.36048C10.6423 7.62917 11.2371 7.03423 11.9681 7.03423C12.699 7.03423 13.2939 7.62917 13.2939 8.36048V9.44105L10.6423 9.44091V8.36048ZM14.8392 14.9117C14.8392 14.9143 14.837 14.9163 14.8348 14.9163H9.10145C9.09914 14.9163 9.09704 14.9144 9.09704 14.9117L9.09719 10.7149C9.09719 10.7123 9.09935 10.7103 9.1016 10.7103H14.8349C14.8372 10.7103 14.8393 10.7122 14.8393 10.7149L14.8392 14.9117Z" fill="#0062FF" stroke="#0062FF" strokeWidth="0.2" strokeLinejoin="round" />
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
                    <path d="M19.6142 2.81004C16.7383 0.974413 13.4042 0 10.0001 0C6.5959 0 3.26215 0.974413 0.385904 2.81004C0.145346 2.96427 -0.000162364 3.2317 1.35964e-07 3.519V10.8375C0.0026043 12.8239 0.571125 14.7675 1.638 16.4377C2.70475 18.1076 4.22475 19.4336 6.01758 20.2579L9.65512 21.9246H9.65496C9.8742 22.0251 10.1258 22.0251 10.345 21.9246L13.9826 20.2579H13.9824C15.7752 19.4336 17.2952 18.1076 18.362 16.4377C19.4289 14.7676 19.9974 12.824 20 10.8375V3.519C20.0002 3.23171 19.8547 2.96428 19.6141 2.81004H19.6142ZM18.3335 10.8375C18.3312 12.5014 17.855 14.1295 16.9614 15.5284C16.0677 16.9273 14.7944 18.0378 13.2926 18.7283L10.0001 20.2361L6.70761 18.724C5.20649 18.0339 3.93353 16.924 3.03999 15.5259C2.14644 14.1278 1.66986 12.5007 1.66678 10.8376V3.98783C4.18811 2.47688 7.06719 1.67934 10.0001 1.67934C12.933 1.67934 15.8122 2.47688 18.3334 3.98783L18.3335 10.8375Z" fill="#0062FF" />
                    <path d="M10.0005 1C5.20053 1 2.00053 3 1.00053 4C0.50053 7.33333 0.053575 15.7004 5.00053 19C6.49977 20 8.5 20.5 10.0005 21C10.5005 20.8333 12.1005 20.2 14.5005 19C20.1005 16.2 19.8339 7.5 19.0005 3.5C18.0005 2.66667 14.8005 1 10.0005 1Z" fill="#0062FF" />
                    <path d="M14.1082 9.71491C14.1082 9.01237 13.5369 8.44126 12.8346 8.44121C12.8345 8.44121 12.8345 8.44121 12.8345 8.44121H12.5629V7.36063C12.5629 5.92947 11.399 4.76523 9.96792 4.76523C8.53687 4.76523 7.37298 5.92943 7.37298 7.36063V8.44121H7.10128C6.39902 8.44121 5.82773 9.01251 5.82773 9.71491V13.9117C5.82773 14.6143 6.39903 15.1854 7.10128 15.1854H12.8346C13.5369 15.1854 14.1082 14.6141 14.1082 13.9117V9.71491ZM8.6423 7.36048C8.6423 6.62917 9.23714 6.03423 9.96809 6.03423C10.699 6.03423 11.2939 6.62917 11.2939 7.36048V8.44105L8.6423 8.44091V7.36048ZM12.8392 13.9117C12.8392 13.9143 12.837 13.9163 12.8348 13.9163H7.10145C7.09914 13.9163 7.09704 13.9144 7.09704 13.9117L7.09719 9.71491C7.09719 9.71232 7.09935 9.71035 7.1016 9.71035H12.8349C12.8372 9.71035 12.8393 9.71222 12.8393 9.71491L12.8392 13.9117Z" fill="white" stroke="white" strokeWidth="0.2" strokeLinejoin="round" />
                  </svg>
                </Button>
              </OverlayTrigger>

            </div>

            {/* <div className="logout" onClick={() => {
              localStorage.clear();
              window.location.reload()
            }}>
              <a className="active"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M17.8657 13.4H9.59236C9.11746 13.4 8.73248 12.9971 8.73248 12.5C8.73248 12.0029 9.11746 11.6 9.59236 11.6H18.2795L17.2351 10.4921C16.9015 10.1383 16.9051 9.56849 17.2432 9.21937C17.5812 8.87025 18.1256 8.87405 18.4592 9.22786L20.7522 11.6601C21.0842 12.0122 21.0824 12.5788 20.7481 12.9286L18.4552 15.3286C18.1194 15.6801 17.5749 15.6801 17.2391 15.3286C16.9033 14.9772 16.9033 14.4073 17.2391 14.0558L17.8657 13.4Z" fill="#696974" />
                <path fillRule="evenodd" clipRule="evenodd" d="M15.6115 19.22V17.3C15.6115 16.1 17.3312 16.1 17.3312 17.3V19.22C17.3312 21.3239 15.5242 23 13.3185 23H7.01274C4.80698 23 3 21.3239 3 19.22V5.78C3 3.6761 4.80698 2 7.01274 2H13.3185C15.5242 2 17.3312 3.6761 17.3312 5.78V7.7C17.3312 8.19706 16.9462 8.6 16.4713 8.6C15.9964 8.6 15.6115 8.19706 15.6115 7.7V5.78C15.6115 4.70583 14.597 3.8 13.3185 3.8H7.01274C5.7342 3.8 4.71975 4.70583 4.71975 5.78V19.22C4.71975 20.2942 5.7342 21.2 7.01274 21.2H13.3185C14.597 21.2 15.6115 20.2942 15.6115 19.22Z" fill="#696974" />
              </svg><span  >Logout</span></a>
            </div> */}
            {this.state.showRedirectConfirmationModal &&
              <AreYouSureModal
                show={this.state.showRedirectConfirmationModal}
                subText={getSubText()}
                closeModal={() => this.setState({ showRedirectConfirmationModal: false })}
                confirmClose={() => {
                  localStorage.removeItem('fb_steps');
                  localStorage.removeItem('project_state');
                  this.navigateToRoute(this.state.redirectURL);
                  this.setState({ showRedirectConfirmationModal: false });
                }}
              />}
          </div >
        )
        }
      </AppContext.Consumer>

    )
  }

  async signOut(setAuthorized) {
    try {

      localStorage.clear();
      // if (evt !== undefined && evt.preventDefault) evt.preventDefault();
      // await Amplify.Auth.signOut();
      // setAuthorized(false)
      window.location.reload()
      // (/login?);
      // await Amplify.Auth.signOut();
      // setAuthorized(false)
      // this.props.history.push('/login');
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

  navigateToRoute(route) {

    this.setState({ currentSelected: route });
    this.props.history.push(route)

  }
}

export default withRouter(SideBar);
